<template>
  <div>
    <!--<div class="box">
    <div class="box-header" />
    <div class="box-header">
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <select v-model="filtro.campanha" class="form-control pull-right">
              <option value="" selected>Campanha</option>
              <option v-for="item in campanhas" :key="item" 
                v-bind:value="item">{{ item }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filtro.investimento" type="number" 
              class="form-control pull-right" placeholder="Investimento">
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filtro.numeroCorrida" type="number"
              class="form-control pull-right" placeholder="Número da corrida">
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <select v-model="filtro.tipoData" class="form-control pull-right" 
              @change="tipoData($event)">
              <option value="0" selected>Filtro para data</option>
              <option v-for="item in tiposData" :key="item.id" 
                v-bind:value="item.id">{{ item.nome }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8" v-if="disabledData">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <vue-pikaday class="form-control" autocomplete="off" 
              v-model="filtro.dataDe" placeholder="Início dd/mm/aaaa" :options="pikadayOptions" />
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8" v-if="disabledData">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <vue-pikaday class="form-control" autocomplete="off" 
              v-model="filtro.dataAte" placeholder="Fim dd/mm/aaaa" :options="pikadayOptions" />
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="padding: 15px 0px 0px 30px;">
      <button type="button" class="btn btn-info" 
        @click="filtrar()"><i class="fa fa-search"></i>
      </button>
      <div class="col-12 col-md-12" style="text-align: center; color: red; padding-bottom: 10px;" 
        v-show="errorFiltroMessage">{{ errorFiltroMessage }}
      </div>
    </div>
    <div class="box-header" />
    <div class="box-header" v-if="mostrar" style="border-top: 1px dashed #d2d6de; border-bottom: 1px dashed #d2d6de; margin-top: 10px;">
      <div class="col-6 col-md-3 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>Quantidade de horas</b>: {{ dashboardRetorno.quantidadeHoras }}
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>Telas Online</b>: {{ dashboardRetorno.telasOnline }}
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>Visualizações</b>: {{ dashboardRetorno.visualizacoes }}
          </div>
        </div>
      </div>
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>OTS</b>: {{ dashboardRetorno.ots }}
          </div>
        </div>
      </div>
      
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>KM percorrido</b>: {{ dashboardRetorno.kmPercorrido }}
          </div>
        </div>
      </div>

      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <b>CPM</b>: R$ {{ formatPrice(dashboardRetorno.cpm) }}
          </div>
        </div>
      </div>
    </div>
    <div class="box-header" v-if="mostrar" />
    <div class="box-header" v-if="mostrar" style="border-top: 1px dashed #d2d6de; border-bottom: 1px dashed #d2d6de; margin-top: 10px;">
      <div class="col-6 col-md-2 col-sm-8 col-xs-8">
        <div class="input-group input-group-sm div-pesquisa">
          <h2>Hotspots - TOP <b>{{ dashboardRetorno.hotspost.length }}</b></h2>
        </div>
        <table>
          <thead>
            <tr v-for="hotspost in dashboardRetorno.hotspost" :key="hotspost.porcentagem">
              <th>{{ hotspost.nome }}: </th>
              <td>{{ hotspost.porcentagem }} %</td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div class="box-header" v-if="mostrar" />
    <div class="box-header" v-if="mostrar">
      <b-tabs>
        <b-tab title="Dashboard" active>
          <highcharts 
            :constructor-type="'chart'" 
            :options="chartOptions">
          </highcharts>
        </b-tab>
        <b-tab title="Mapa de calor">
          <vue-google-heatmap
            v-if="mostrar"
            :initial-zoom="10"
            :lat="lat"
            :lng="lng"
            :points="points"
            :width="1600"
            :height="800" />
        </b-tab>
      </b-tabs>
    </div>
  </div>-->
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import DashboardActions from "../../actions/DashboardActions";
import * as FormInputOptions from "./../../helpers/FormInputOptions";
import moment from "moment";
import VueGoogleHeatmap from "vue-google-heatmap";

Vue.use(VueGoogleHeatmap, {
  apiKey: process.env.GOOGLE_MAPA
});

export default {
  name: "Dashboard",
  components: {
    highcharts: Chart,
    Highcharts
  },
  data() {
    return {
      title: "Dashboard",
      width: 0,
      height: 0,
      filtro: {
        investimento: "",
        numeroCorrida: "",
        campanha: "",
        dataDe: null,
        dataAte: null,
        tipoData: "0"
      },
      errorFiltroMessage: null,
      pikadayOptions: FormInputOptions.PikadayOptions,
      campanhas: [],
      dashboardRetorno: {},
      datacollection: null,
      chartOptions: {},
      mostrar: false,
      points: [],
      lat: null,
      lng: null,
      tiposData: [],
      disabledData: false
    };
  },
  mounted() {
    /*this.$parent.$data.description = 'Detalhes'
      this.$parent.$data.title = this.title
      this.$parent.$parent.$data.showModalLoader = true
      this.listarCampanhas()
      this.listarTiposData()
      this.filtro.tipoData = '0'*/
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async filtrar() {
      this.points = [];
      this.mostrar = false;
      if (
        this.filtro.investimento ||
        this.filtro.numeroCorrida ||
        this.filtro.dataDe ||
        this.filtro.dataAte
      ) {
        this.$parent.$data.showModalLoader = true;
        this.errorFiltroMessage = null;
        let dataDe = null;
        let dataAte = null;
        if (
          this.filtro.tipoData === 3 &&
          this.filtro.dataDe != null &&
          this.filtro.dataAte != null
        ) {
          dataDe = moment(this.filtro.dataDe);
          dataDe =
            dataDe.year() + "-" + (dataDe.month() + 1) + "-" + dataDe.date();
          dataAte = moment(this.filtro.dataAte);
          dataAte =
            dataAte.year() + "-" + (dataAte.month() + 1) + "-" + dataAte.date();
        }
        let urlApi =
          "?investimento=" +
          this.filtro.investimento +
          "&numeroCorrida=" +
          this.filtro.numeroCorrida +
          "&tipoData=" +
          this.filtro.tipoData +
          "&dataDe=" +
          dataDe +
          "&dataAte=" +
          dataAte +
          "&campanha=" +
          this.filtro.campanha;
        await DashboardActions.pesquisar(urlApi)
          .then(res => {
            this.dashboardRetorno = res;
            this.$parent.$data.showModalLoader = false;
            this.chartOptions = res.grafico;
            this.mostrar = true;
            this.points = res.mapaCalor;
            this.lat = res.local.lat;
            this.lng = res.local.lng;
          })
          .catch(() => {
            this.mostrar = false;
            this.dashboardRetorno = {};
            this.$parent.$data.showModalLoader = false;
            this.errorFiltroMessage =
              "Erro ao consultar no servidor, tente novamente mais tarde !";
          });
      } else {
        this.mostrar = false;
        this.errorFiltroMessage = "Campos com * são obrigatórios.";
      }
    },
    async listarCampanhas() {
      this.$parent.$data.showModalLoader = true;
      await DashboardActions.listarCampanhas()
        .then(res => {
          this.campanhas = res;
          this.$parent.$data.showModalLoader = false;
        })
        .catch(error => {
          this.$parent.$data.showModalLoader = false;
          this.errorFiltroMessage = error.response.data.error;
        });
    },
    async listarTiposData() {
      this.tiposData = [];
      this.tiposData.push(
        { id: 1, nome: "Últimos 30 dias" },
        { id: 2, nome: "Últimos 15 dias" },
        { id: 3, nome: "Customizado" }
      );
    },
    /* eslint-disable */
    tipoData(event) {
      this.filtro.dataDe = null;
      this.filtro.dataAte = null;
      if (event.target.value == 3) {
        this.disabledData = true;
      } else {
        this.disabledData = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue